export const GET_SMS_CAMPAIGNS_REQUEST = 'USER_GET_SMS_CAMPAIGNS_REQUEST';
export const GET_SMS_CAMPAIGNS_SUCCESS = 'USER_GET_SMS_CAMPAIGNS_SUCCESS';
export const GET_SMS_CAMPAIGNS_FAILURE = 'USER_GET_SMS_CAMPAIGNS_FAILURE';

export const DELETE_SMS_CAMPAIGN_REQUEST = 'USER_DELETE_SMS_CAMPAIGN_REQUEST';
export const DELETE_SMS_CAMPAIGN_SUCCESS = 'USER_DELETE_SMS_CAMPAIGN_SUCCESS';
export const DELETE_SMS_CAMPAIGN_FAILURE = 'USER_DELETE_SMS_CAMPAIGN_FAILURE';

export const PUT_SMS_CAMPAIGN_REQUEST = 'USER_PUT_SMS_CAMPAIGN_REQUEST';
export const PUT_SMS_CAMPAIGN_SUCCESS = 'USER_PUT_SMS_CAMPAIGN_SUCCESS';
export const PUT_SMS_CAMPAIGN_FAILURE = 'USER_PUT_SMS_CAMPAIGN_FAILURE';

export const POST_SMS_CAMPAIGN_REQUEST = 'USER_POST_SMS_CAMPAIGN_REQUEST';
export const POST_SMS_CAMPAIGN_SUCCESS = 'USER_POST_SMS_CAMPAIGN_SUCCESS';
export const POST_SMS_CAMPAIGN_FAILURE = 'USER_POST_SMS_CAMPAIGN_FAILURE';

export const POST_SEND_SMS_REQUEST = 'USER_POST_SEND_SMS_REQUEST';
export const POST_SEND_SMS_SUCCESS = 'USER_POST_SEND_SMS_SUCCESS';
export const POST_SEND_SMS_FAILURE = 'USER_POST_SEND_SMS_FAILURE';

export const POST_ASSOCIATE_WITH_SMS_CAMPAIGN_REQUEST = 'USER_POST_ASSOCIATE_WITH_SMS_CAMPAIGN_REQUEST';
export const POST_ASSOCIATE_WITH_SMS_CAMPAIGN_SUCCESS = 'USER_POST_ASSOCIATE_WITH_SMS_CAMPAIGN_SUCCESS';
export const POST_ASSOCIATE_WITH_SMS_CAMPAIGN_FAILURE = 'USER_POST_ASSOCIATE_WITH_SMS_CAMPAIGN_FAILURE';
